import config from 'config'

/**
 * This makes mocking the config object easier.
 */
export const getConfig = () => {
  return config
}
